<template>
  <v-card class="event-summary" :to="route">
    <span class="H5 primary-text text--darken-1 one-line">{{ title }}</span>
    <span class="label one-line" v-if="location"><v-icon small class="material-symbols-rounded" color="primary lighten-1">pin_drop</v-icon>{{ location }}</span>
    <span class="label one-line" v-if="requiresReservation"><v-icon small class="material-symbols-rounded" color="primary lighten-1">calendar_add_on</v-icon>{{ $t('upcoming_events.requires_reservation') }}</span>
    <span class="label one-line"><v-icon small class="material-symbols-rounded" color="primary lighten-1">schedule</v-icon>{{ start }} - {{ end }}</span>
  </v-card>
</template>
<script>
import moment from 'moment'
import { getTextValue } from '@/lib/helpers/LocalizedText'
import { getTimeFormat } from '@/lib/helpers/HoursFormatter'
import routeNames from '@/router/routes'
import { reservationTypes } from '@/config'
export default {
  props: {
    event: Object,
  },
  computed: {
    route () {
      return { name: routeNames.page_details.name, params: { pageId: this.event.pageId }}
    },
    title () {
      return getTextValue(this.event.title)
    },
    location () {
      return this.event.location ? getTextValue(this.event.location.name) : null
    },
    start () {
      return moment.utc(this.event.start).format(getTimeFormat())
    },
    end () {
      return moment.utc(this.event.end).format(getTimeFormat())
    },
    requiresReservation () {
      return !!this.event.reservationMethods.find((method) => {
        return method.type === reservationTypes.IN_VENUE
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.event-summary {
  align-self: flex-start;
  padding: 15px;
  min-width: 142px;
  border-radius: 10px;
  border: 1px solid var(--v-custom-grey-lighten1);
  background: #FFF;
  box-shadow: 0px 0px 17.86666px 0px rgba(0, 0, 0, 0.10) !important;
  gap: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  span {
    border-radius: 0 !important;
  }
  .one-line {
    max-width: calc(100%);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .v-icon {
    margin-right: 5px;
  }
  span.label {
    color: var(--v-grey-2-base);
    font-family: 'Mukta Mahee';
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 166.667% */
    letter-spacing: 0.25px;
  }
}
</style>